import { isEmpty } from 'lodash';
import React from 'react';

import appleBlackLogoSrc from '../../../../assets/images/apple_black_logo.svg';

export default function MarketingLeadCaptureWithApple({
  eventName,
  returningUri,
  verificationUri,
}: {
  eventName: string;
  leadType: string;
  returningUri?: string;
  verificationUri: string;
}) {
  const appleId = window['AppleID'];
  const appleIdScriptLoaded = !isEmpty(appleId);

  if (!appleIdScriptLoaded) return null;

  return (
    <div
      id="apple-btn-container"
      data-event-name={eventName}
      data-verification-uri={verificationUri}
      data-return-uri={returningUri}
      onClick={() => appleId.auth.signIn()}
    >
      <img src={appleBlackLogoSrc} />
      <div className="apple-label">Continue with Apple</div>
    </div>
  );
}
